// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
    min-height: 100vh;
}

.heading-font {
    font-family: 'Cinzel', serif;
}

.body-font {
    font-family: 'Lato', sans-serif;
}

@keyframes pulse-gold {
    0%, 100% {
        opacity: 1;
        transform: scale(1);
    }
    50% {
        opacity: 0.8;
        transform: scale(1.05);
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI;QACI,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,sBAAsB;IAC1B;AACJ","sourcesContent":[".App {\n    min-height: 100vh;\n}\n\n.heading-font {\n    font-family: 'Cinzel', serif;\n}\n\n.body-font {\n    font-family: 'Lato', sans-serif;\n}\n\n@keyframes pulse-gold {\n    0%, 100% {\n        opacity: 1;\n        transform: scale(1);\n    }\n    50% {\n        opacity: 0.8;\n        transform: scale(1.05);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
